module.exports = __webpack_public_path__ + "static/media/why-no.c60edfeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/why-no.png
// module id = 1524
// module chunks = 0